import {useMemo, useEffect} from 'react'
import {useTable} from 'react-table'

import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {useSearchCertificatesColumns} from './columns/_columns'

import { LoadingIndicator } from '../../../../components/widgets'
import { KTCardBody } from '../../../../../_metronic/helpers'
import { TableBody, TableHead, TablePagination } from '../../../../components/table'

import { useQueryRequest } from '../core/QueryRequestProvider'
import { orderBy } from 'lodash'

const CertificatesTable = () => {
  
  const { state, updateState } = useQueryRequest();
  const { page, items_per_page, nrecs, sort, order} = state;

  const certificates = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  
  const sorted = useMemo(() => {            
    return orderBy(certificates,[sort || 'cocNumber'],[order || 'asc']);
  }, [certificates, order, sort])

  const columns = useSearchCertificatesColumns();

  const show_data = useMemo(() => {
    return sorted.slice(((page - 1) * items_per_page), page * items_per_page);
  }, [sorted, page, items_per_page]);

  const {getTableProps, getTableBodyProps, headers, headerGroups, rows, prepareRow} = useTable({
    columns,
    data: show_data,
  })

  useEffect(()=> {
    const d_cnt = certificates?.length ?? 0;
    if (nrecs !== d_cnt) {
      updateState({nrecs : d_cnt});            
    }                
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificates, nrecs]);


  return (
  <KTCardBody className='py-10'>
    <h1>
      Search Results            
    </h1>        
    <small className="text-muted">
      (Only a maximum of 5 results will be shown.)
    </small>
    <div className='table-responsive'>
      <table
        id='kt_table_certificates'
        className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer'
        {...getTableProps()}
      >
        <TableHead {...{headerGroups, sort, order, updateState}} />
        <TableBody        
          getTableBodyProps={getTableBodyProps}
          rows={rows}
          prepareRow={prepareRow}
          isLoading={isLoading}
          colSpan={headers.length}
        />              
      </table>
    </div>
    <TablePagination isLoading={isLoading} updateState={updateState} state={state} />
    <LoadingIndicator display={(isLoading)} status_text="Searching" />
  </KTCardBody>
  )
}

export {CertificatesTable}
